<ion-header #fixedHeader (mouseenter)='scrollUp($event)'>
  <app-page-header backName='Lesson Plans' popoverCssClass='lesson-plans' sourcePage={{sourcePage}}></app-page-header>

  <div class='top'>
    <div class='contents'>
      <div class='left'>
        <button class='week' (click)='presentLessonSelectorPopover($event)'>{{lesson.name}}<i class='mt-arrow-down'></i></button>
        <img class='metrics' [hidden]='true'>
        <section>
            <svg viewBox="0 0 40 40" class="circular-chart">
              <path class="circle-bg"
                    d="M20 5
                      a 15 15 0 0 1 0 30
                      a 15 15 0 0 1 0 -30"
              />
              <path class="circle" [style.strokeDasharray]='svgProgress()'
                    d="M20 5
                        a 15 15 0 0 1 0 30
                        a 15 15 0 0 1 0 -30"
              />
            </svg>
          <button class='plan'>{{percentValid()}}% Goals Met</button>
        </section>
      </div>
      <div class='right'>
        <button class='bowling-button' (click)='gotoBowlingPage(course)'><i class='mt-bowling'></i></button>
        
        <div class='action-buttons'>
          <button class='actions' [hidden]='isEditing' (click)='presentLessonActionPopover($event)'>Actions<i class='mt-arrow-down'></i></button>
          <button [ngClass]="{'offline': true, 'disabled' : true }" id="offline-button" [disabled]="true" [hidden]="isOnline">
            <i class="mt-alert"></i> Offline
          </button>
          <button [ngClass]="{'edit': true, 'disabled' : !isDataSaving }" id="click-trigger" [disabled]="isDataSaving" [hidden]="!isOnline">
            {{isDataSaving ? 'Saving...' : 'Autosave' }}
          </button>
          <ion-popover trigger="click-trigger" showBackdrop="false" triggerAction="click">
            <ng-template>
              <ion-content class="ion-padding autosave-popup">
                <h3>Auto-save!</h3>
                <p>Auto-save, auto-save, all the time!</p>
                <div class="friend"><img src="../../../assets/friends/Friend-Flourish-02_RED-sm.png" alt="" /></div>
              </ion-content>
            </ng-template>
          </ion-popover>
        </div>
      </div>
    </div>

    <div [ngClass]="['bar', lessonSongCssService.responsiveClass()]" [style.marginLeft.px]='columnNamesMarginLeft'>
      <div [ngClass]="['titles', lessonSongCssService.responsiveClass()]">
        <app-resizeable-column [columnName]="'name'" [columnText]="'Song Name'" ></app-resizeable-column>
        <section class='details' (scroll)='onScroll($event)' [scrollLeft]='scrollLeft' [style.width.px]='lessonSongCssService.detailColumnWidth'>
          <app-resizeable-column [columnName]="'tonality'" [columnText]="'Tonality (SP)'" [hidden]='!lessonPrefs.tonalityShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'meter'" [columnText]="'Meter'" [hidden]='!lessonPrefs.meterShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'swow'" [columnText]="'SWOW'" [hidden]='!lessonPrefs.swowShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'activity'" [columnText]="'Activity'"  [hidden]='!lessonPrefs.activityShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'rp'" [columnText]="'RP'" [hidden]='!lessonPrefs.rpShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'tp'" [columnText]="'TP'" [hidden]='!lessonPrefs.tpShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'instrument'" [columnText]="'Inst/Prop'" [hidden]='!lessonPrefs.instrumentShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'recording'" [columnText]="'Recording'" [hidden]='!lessonPrefs.recordingShown'></app-resizeable-column>
          <app-resizeable-column [columnName]="'pem'" [columnText]="pemName" [hidden]='!lessonPrefs.pemShown'></app-resizeable-column>
        </section>
        <app-resizeable-column [columnName]="'info'" [columnText]="''" ></app-resizeable-column>
      </div>
    </div>
  </div>
</ion-header>

<ion-content id='main-content' appScrollBounce>
  <div class='middle'>
    <table class='songs' (scroll)='onScroll($event)' [scrollLeft]='scrollLeft'>
      <thead>
      <tr>
        <th>Song Name</th>
        <th>Tonality (SP)</th>
        <th>Meter</th>
        <th>SWOW</th>
        <th>Activity</th>
        <th>RP</th>
        <th>TP</th>
        <th>Inst/Prop</th>
        <th>Recording</th>
        <th class='pem-column'>{{pemName}}</th>
      </tr>
      </thead>
      <tbody [dragula]='dragGroupName' [(dragulaModel)]='songs'>
        <ng-container *ngFor='let song of songs ; index as index; trackBy: trackBySongUuid'>
          <tr app-lesson-song [song]='song' 
                              [course]='course'
                              [lesson]='lesson'
                              [index]='index'
                              [isEditing]='isEditing'
                              [teacher]='teacher'
                              [resources]='resources'
                              (addSong)='addSong($event)'
                              (showSongInfo)='showSongInfo($event)'
                              (togglePem)='togglePem($event)'
                              (playRecording)='playRecording($event)'
                              (autoSave)='autoSave($event)'
          ></tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <div [ngClass]="['bottom', lessonSongCssService.responsiveClass()]">
    <div class='info'>
      <div class='checklist'>
        <h3>Checklist</h3>
        <p [ngClass]='nondupleValidate().textClass'><i [ngClass]='nondupleValidate().iconClass'></i>{{nondupleValidate().message}}</p>
        <p [ngClass]='nonmajorValidate().textClass'><i [ngClass]='nonmajorValidate().iconClass'></i>{{nonmajorValidate().message}}</p>
        <p [ngClass]='swowValidate().textClass' [hidden]='!hasSwows'><i [ngClass]='swowValidate().iconClass'></i>{{swowValidate().message}}</p>
        <p [ngClass]='instrumentValidate().textClass'><i [ngClass]='instrumentValidate().iconClass'></i>{{instrumentValidate().message}}</p>
        <p [ngClass]='recordingValidate().textClass'><i [ngClass]='recordingValidate().iconClass'></i>{{recordingValidate().message}}</p>
        <p [ngClass]='tpValidate().textClass'><i [ngClass]='tpValidate().iconClass'></i>{{tpValidate().message}}</p>
        <p [ngClass]='rpValidate().textClass' [hidden]='!hasRhythmPatterns' ><i [ngClass]='rpValidate().iconClass'></i>{{rpValidate().message}}</p>
        <p [ngClass]='pemValidate().textClass' [hidden]='!hasPems'><i [ngClass]='pemValidate().iconClass'></i>{{pemValidate().message}}</p>
      </div>
      <div class='notes'>
        <div class='header'>
          <h3>Notes </h3>
          <div class='buttons'>
            <button class='edit' [hidden]='isEditingNotes' (click)='editNotes()'>Edit</button>
            <button class='cancel' [hidden]='!isEditingNotes' (click)='cancelNotes()'>Cancel</button>
            <button class='save' [hidden]='!isEditingNotes' (click)='saveNotes()'>Save</button>
          </div>
        </div>
        <textarea id='notes-normal' [style.height]='cssUtilitiesService.textareaHeight("notes-normal", 250)' [hidden]='isEditingNotes' [readOnly]='true' placeholder='Enter notes for your lesson'>{{isEditing ? lessonBeingEdited.notes : lesson.notes}}</textarea>
        <textarea id='notes-editing' [style.height]='cssUtilitiesService.textareaHeight("notes-editing", 250)' class='editing' [hidden]='!isEditingNotes' [readOnly]='false' placeholder='Enter notes for your lesson' [(ngModel)]='notesBeingEdited'></textarea>
      </div>
      <img class='friend' src='assets/friends/Friends-LessonPlan.gif'>
    </div>
  </div>
</ion-content>

<ion-menu menuId="song-details-lesson-page-menu" class="song-details-lesson-page-menu" type='overlay' side='end' (ionDidClose)='closeMenu()'>
  <ion-content>
    <div class='menu add-song-slideout' *ngIf='addSongShown'>
      <app-add-songs-slideout [course]='course' [lesson]='lesson' [addSongHandler]='addSongHandler'></app-add-songs-slideout>
    </div>

    <div class='menu song-detail-slideout' *ngIf='songDetailShown'>
      <div class='header'>
        <div class='title-area'>
          <div class='menu' *ngIf='addSongShown'>
            <app-add-songs-slideout [course]='course' [lesson]='lesson' [addSongHandler]='addSongHandler'></app-add-songs-slideout>
          </div>
          <button class='done' (click)='doneSongDetail()'>Done</button>
          <button class='remove' (click)='removeSong()'><i class='mt-minus'></i>Remove Song</button>
        </div>
      </div>

      <app-song-detail [course]='course' [song]='songInfoSong'></app-song-detail>
    </div>

    <div class='menu add-pem-slideout' *ngIf='addPemShown'>
      <app-add-pem-slideout [pemName]="pemName" [addPemHandler]='addPemHandler'></app-add-pem-slideout>
    </div>

    <div class='menu pem-detail-slideout' *ngIf='pemDetailShown'>
        <div class='header'>
        <div class='title-area'>
          <button class='done' (click)='donePemDetail()'>Done</button>
          <button class='remove' (click)='removePem()'><i class='mt-minus'></i>Remove {{pemName}}</button>
        </div>
      </div>
        
      <app-pem-detail [pem]='pemDetailPem'></app-pem-detail>
    </div>
  </ion-content>
</ion-menu>